import { Alert as AntdAlert } from "antd";
import styled from "styled-components";
export const Alert = styled(AntdAlert)`
  border-radius: ${(props) => props.theme.border.radius};
`;
